import { MenuItem, Select } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import OptionAddon from "./optionAddon";

const typeList = [
  {
    name: "text",
  },
  {
    name: "number",
  },
  {
    name: "password",
  },
  {
    name: "email",
  },
  {
    name: "date",
  },
  {
    name: "time",
  },
  {
    name: "file",
  },
  {
    name: "radio",
  },
  {
    name: "checkbox",
  },
  {
    name: "date-time-local",
  },
  {
    name: "select",
  },
  // {
  //   name: "multiselect",
  // },
];

const optionObj = {
  title: "",
  value: "",
};
const Addons = ({ data, handleChange, handleSaveField, activeTab }) => {
  const [state, setState] = useState({
    addons: data,
  });
  console.log(data, "datadatadatadatadatadatadata");
  const [isChange, setIsChange] = useState(false);
  const [saveChange, setSaveChange] = useState(false);
  const [addState, setAddState] = useState({
    title: "",
    type: "",
    placeholder: "",
    option: [],
  });

  useEffect(() => {
    setState({ addons: data });
  }, [data]);

  useEffect(() => {
    if (activeTab === "personalInfo") {
      handleChange(state.addons, "personal_information");
    } else if (activeTab === "empInfo") {
      handleChange(state.addons, "employment_information");
    } else if (activeTab === "otherFinancialInfo") {
      handleChange(state.addons, "other_financial_information");
    } else if (activeTab === "personalAssets") {
      handleChange(state.addons, "personal_assets");
    } else if (activeTab === "realPropertyOwned") {
      handleChange(state.addons, "real_property_owned");
    } else if (activeTab === "vehicles") {
      handleChange(state.addons, "vehicles");
    } else if (activeTab === "assets") {
      handleChange(state.addons, "assets");
    } else if (activeTab === "incomeExpenseStatement") {
      handleChange(state.addons, "income");
    } else if (activeTab === "legal") {
      handleChange(state.addons, "legal");
    } else if (activeTab === "bankruptcy") {
      handleChange(state.addons, "bankruptcy");
    }
  }, [isChange]);

  const addRow = (e) => {
    e.preventDefault();
    setState((pre) => ({
      ...pre,
      addons: [...pre.addons, addState],
    }));
  };

  const deleteRow = (e, index) => {
    e.preventDefault();
    const addons = state.addons.filter((e, i) => i !== index);
    setState({
      addons: [...addons],
    });
    setIsChange(!isChange);
    setSaveChange(!saveChange);
    // if (state.addons.length === 1) {
    //   handleSaveField();
    // }
  };

  // useEffect(() => {
  //   if (state.addons.length > 0) {
  //     handleSaveField();
  //   }
  // }, [JSON.stringify(state.addons)]);

  const addOptionRow = (e, i) => {
    e.preventDefault();
    setState((pre) => ({
      ...pre,
      addons: [
        ...pre.addons.slice(0, i),
        {
          ...pre.addons[i],
          option: [...pre.addons[i].option, optionObj],
        },

        ...pre.addons.slice(i + 1),
      ],
    }));
  };

  const deleteOptionRow = (e, i, optionIndx) => {
    e.preventDefault();
    setState((pre) => ({
      ...pre,
      addons: [
        ...pre.addons.slice(0, i),
        {
          ...pre.addons[i],
          option: pre.addons[i].option.filter((_, indx) => indx !== optionIndx),
        },

        ...pre.addons.slice(i + 1),
      ],
    }));
  };

  const changeRowvalue = (e, i, optionIndx) => {
    const { name, value } = e.target;

    if (optionIndx >= 0) {
      setState((pre) => ({
        ...pre,
        addons: [
          ...pre.addons.slice(0, i),
          {
            ...pre.addons[i],
            option: [
              ...pre.addons[i].option.slice(0, optionIndx),
              {
                ...pre.addons[i].option[optionIndx],
                [name]: value,
              },
              ...pre.addons[i].option.slice(optionIndx + 1),
            ],
          },

          ...pre.addons.slice(i + 1),
        ],
      }));
    } else {
      setState((pre) => ({
        ...pre,
        addons: [
          ...pre.addons.slice(0, i),
          {
            ...pre.addons[i],
            [name]: value,
          },

          ...pre.addons.slice(i + 1),
        ],
      }));
    }
    setIsChange(!isChange);
  };

  return (
    <>
      {state.addons &&
        state.addons.map((s, i) => {
          return (
            <div className="my-2">
              <Row className="align-items-center columns-fields">
                <Col md={3} className="range-inner">
                  <label htmlFor="title">Title</label>
                  <input
                    type="text"
                    name="title"
                    value={s.title}
                    onChange={(e) => changeRowvalue(e, i)}
                    placeholder=""
                    className="form-control"
                  />
                </Col>
                <Col
                  md={3}
                  className="range-inner doc-select field-type-select"
                >
                  <label htmlFor="title">Type</label>
                  <Select
                    className="demo-simple-select-label"
                    id="demo-simple-select"
                    name="type"
                    value={s.type}
                    onChange={(e) => changeRowvalue(e, i)}
                    MenuProps={typeList}
                  >
                    {typeList &&
                      typeList.length > 0 &&
                      typeList.map((item, idx) => {
                        return (
                          <MenuItem key={item.name} value={item.name}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </Col>
                <Col md={3} className="range-inner">
                  <label htmlFor="title">Placeholder</label>
                  <input
                    type="text"
                    name="placeholder"
                    value={s.placeholder}
                    onChange={(e) => changeRowvalue(e, i)}
                    placeholder=""
                    className="form-control"
                  />
                </Col>
                <Col md={3}>
                  <div className=" text-end pt-4">
                    <button
                      className="remove-btn address-btn-remove address-remove position-relative"
                      onClick={(e) => deleteRow(e, i, "addons")}
                    >
                      Remove Field
                    </button>
                  </div>
                </Col>
                {(s.type === "radio" ||
                  s.type === "checkbox" ||
                  s.type === "select" ||
                  s.type === "multiselect") && (
                  <Col md={4} className="range-inner pt-2">
                    <label htmlFor="title">Options for Field</label>
                    <OptionAddon
                      handleChange={changeRowvalue}
                      detail={s}
                      data={s.option}
                      index={i}
                      deleteRow={deleteOptionRow}
                      addRow={addOptionRow}
                    />
                  </Col>
                )}

                {/* {i ? ( */}
                {/* <div className="col-md-12 text-end pt-4">
                  <button
                    className="remove-btn remove-btn-field address-remove position-relative"
                    onClick={(e) => deleteRow(e, i, "addons")}
                  >
                    Remove Field
                  </button>
                </div> */}
                {/* ) : (
                  ""
                )} */}
              </Row>
            </div>
          );
        })}
      {/* {state.addons?.length > 0 && ( */}
      <div className="text-end pt-3">
        <button className="save-btn-field" onClick={handleSaveField}>
          Save
        </button>
      </div>
      {/* )} */}
      <div className="expension-btn text-left">
        <button
          type="button"
          className="expension-button text-center"
          data-toggle="modal"
          data-target="#exampleModalScrollable1"
          onClick={(e) => addRow(e, "addons")}
        >
          Add More Field
        </button>
      </div>
    </>
  );
};

export default React.memo(Addons);
